import { useEffect, useState } from 'react'
import ChatMessage from './ChatMessage'
import { useDispatch, useSelector } from 'react-redux'

import { addMessage, clearMessages } from '../utils/chatSlice'
import { generateId, getRandomName, getRandomSentence } from '../utils/helper'
import { CHAT_POLL_INTERVAL, MAX_MESSAGE_LENGTH } from '../utils/constants'

const LiveChat = () => {
    const [liveMessage, setLiveMessage] = useState("")

    const dispatch = useDispatch()
    const chatMessages = useSelector(store => store.chat.messages)

    useEffect(() => {
        const intervalId = setInterval(() => {
            // API polling
            dispatch(addMessage({
                id: generateId(),
                name: getRandomName(),
                text: getRandomSentence()
            }))
        }, CHAT_POLL_INTERVAL)

        return () => {
            clearInterval(intervalId)
            dispatch(clearMessages())
        }
    }, [dispatch])

    const handleSubmit = (e) => {
        e.preventDefault()

        const trimmed = liveMessage.trim()
        if (!trimmed.length || trimmed.length > MAX_MESSAGE_LENGTH) return
        dispatch(addMessage({
            id: generateId(),
            name: "Vaibhav Madan",
            text: trimmed
        }))
        setLiveMessage("")
    }

    return (
        <div className="w-full lg:w-96 lg:max-w-96">
            <div className="overflow-y-scroll h-[250px] sm:h-[300px] lg:h-[400px] border border-gray-300 rounded-lg bg-slate-50 flex flex-col-reverse">
                <div>
                    {chatMessages.map((c) => <ChatMessage key={c.id} name={c.name} message={c.text} />)}
                </div>
            </div>
            <form onSubmit={handleSubmit} className="flex mt-2 gap-2">
                <input value={liveMessage}
                    onChange={e => setLiveMessage(e.target.value)}
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-blue-400"
                    placeholder="Send a message..."
                    aria-label="Chat message"
                />
                <button type="submit" className="px-4 py-2 bg-green-500 text-white rounded-lg text-sm font-medium hover:bg-green-600 transition-colors">Send</button>
            </form>
        </div>
    )
}

export default LiveChat